// =====================================================================
// «NO FUI YO» DE UNA RECUPERACIÓN · ESTABILIDAD F6 · E2.4
// =====================================================================
// Se abre desde el aviso que reciben TODOS los contactos de la cuenta
// (actuales y anteriores) cuando alguien pide recuperarla:
// `/app?ir=recuperar-no-fui-yo&t=<token>&c=<empresa>`. Sin sesión.
//
// Un toque más, igual que el «No fui yo» de F4: algunos programas de
// correo abren los enlaces solos para revisarlos, y un revisor automático
// no debe detener una recuperación. El enlace enseña esta pantalla y el
// botón hace la detención.
import { useState } from 'react';
import { ShieldAlert, Loader2, CheckCircle2 } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';

export default function RecuperacionNoFuiYo({ token, empresa }) {
  const [estado, setEstado] = useState('pregunta');
  const [respuesta, setRespuesta] = useState(null);
  const [error, setError] = useState(null);

  async function detener() {
    setEstado('enviando');
    setError(null);
    try {
      setRespuesta(await api.post('/recuperacion/no-fui-yo', { token, empresa }));
      setEstado('hecho');
    } catch (e) {
      setError(e.message || 'No se detuvo la recuperación. Revisa la conexión y vuelve a pulsar.');
      setEstado('pregunta');
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="mx-auto max-w-md space-y-4 rounded-2xl border border-gray-200 bg-white p-5">
        <div className="flex items-start gap-3">
          <ShieldAlert className="h-7 w-7 shrink-0 text-red-600" aria-hidden="true" />
          <div>
            <h1 className="text-xl font-semibold text-gray-900">¿No pediste recuperar la cuenta?</h1>
            <p className="text-sm text-gray-600">Detén de un toque la recuperación que se pidió.</p>
          </div>
        </div>
        <Ayuda id="seguridad.recuperacion_no_fui_yo.pantalla" />
        {estado !== 'hecho' ? (
          <>
            <button type="button" onClick={detener} disabled={estado === 'enviando'}
                    className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-3 text-base font-semibold text-white disabled:opacity-60">
              {estado === 'enviando' && <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />}
              No fui yo: detener la recuperación
            </button>
            <Ayuda id="seguridad.recuperacion_no_fui_yo.boton" />
            {error && <p role="alert" className="rounded-lg border border-red-200 bg-red-50 p-2.5 text-sm text-red-700">{error}</p>}
            <a href="/app" className="block text-center text-sm text-gray-600 underline">Sí fui yo: ir a TEGO</a>
          </>
        ) : (
          <div role="status" className="space-y-3">
            <p className="flex items-center gap-2 font-medium text-green-800">
              <CheckCircle2 className="h-5 w-5" aria-hidden="true" /> La recuperación quedó detenida.
            </p>
            <p className="text-sm text-gray-700">{respuesta?.mensaje}</p>
          </div>
        )}
      </div>
    </div>
  );
}
